import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { API } from '../execShared';

export default function CampaignsSection() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/campaigns`).then(r => setCampaigns(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-4" data-testid="browse-campaigns-section">
      <h2 className="font-display text-2xl font-bold">Browse <span className="text-[#FF4343]">Campaigns</span></h2>
      {loading ? <p className="text-[#9CA3AF]">Loading...</p> : campaigns.length === 0 ? <p className="text-[#9CA3AF]">No campaigns available.</p> : (
        <div className="space-y-3">
          {campaigns.map(c => (
            <Link key={c.id} to={`/campaigns/${c.id}`} data-testid={`dash-campaign-${c.id}`}
              className="block bg-[#111827] border border-white/10 hover:border-white/20 p-4 transition-colors">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-medium text-white">{c.title}</h3>
                  <p className="text-xs text-[#6B7280] mt-1">{c.brand_name} &middot; {c.industry} &middot; {c.budget_range}</p>
                </div>
                <ChevronRight className="w-5 h-5 text-[#6B7280]" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

